import { Component, OnInit, ElementRef, ViewChild, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { MapsAPILoader , MouseEvent} from '@agm/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isPlatformBrowser } from '@angular/common';
import { Iaddress } from 'my-lib-sanfelici/my-lib-sanfelici';
import { AddressService } from 'my-lib-sanfelici';
import { AuthService } from 'my-lib-sanfelici';

export interface DialogData {
  address: Iaddress;

}
@Component({
  selector: 'app-new-maps-dialog-view',
  templateUrl: './new-maps-dialog-view.component.html',
  styleUrls: ['./new-maps-dialog-view.component.scss']
})
export class NewMapsDialogViewComponent implements OnInit {
  title = 'AGM project';
  latitude: number;
  longitude: number;
  zoom: number;
  posizione: Iaddress;
  address: Iaddress;
  private geoCoder;
usr: firebase.User;
isBrowser: boolean;
  @ViewChild('search', {static: true})
  public searchElementRef: ElementRef;
  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private authservice: AuthService,
    private addressservice: AddressService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.authservice.usr.subscribe(u =>
      {
        this.usr = u;
      }
      );
  }

  ngOnInit() {

    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ['address']
      });
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();

          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          // set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
          this.getAddress(this.latitude, this.longitude);
        });
      });
    });
  }
// Get Current Location Coordinates
private setCurrentLocation() {
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition((position) => {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      this.zoom = 15;
      this.getAddress(this.latitude, this.longitude);

    });
  }
}
markerDragEnd($event: MouseEvent) {
  console.log($event);
  this.latitude = $event.coords.lat;
  this.longitude = $event.coords.lng;
  this.getAddress(this.latitude, this.longitude);
}

getAddress(latitude, longitude) {
  this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } },
     (results, status) => {

    console.log(results);
    console.log(status);
    if (status === 'OK') {
      if (results[0]) {

        this.address = this.addressservice.getAddress(results[0]);
        this.address.latitude = latitude;
        this.address.longitude = longitude;
        this.zoom = 12;


      } else {
        
      }
    } else {
      
    }

  });
}
}
